module.exports = __webpack_public_path__ + "media/images/badge/debuttante-2bcb7523771b0369431940c42ad2a9b2.png";